import { render, staticRenderFns } from "./SpinnerWheelEntries.vue?vue&type=template&id=28f95650&scoped=true&"
import script from "./SpinnerWheelEntries.vue?vue&type=script&lang=js&"
export * from "./SpinnerWheelEntries.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerWheelEntries.vue?vue&type=style&index=0&id=28f95650&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f95650",
  null
  
)

export default component.exports